<template>
  <base-chart-card
    color="#90A4AE"
  >
    <template v-slot:heading>
      <base-pie-chart
        v-if="showChart"
        :chart-data="dataCollection"
        :options="options"
        style="max-height: 150px;"
      />
    </template>
    <template v-slot:reveal-actions>
      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            color="info"
            icon
            v-on="on"
          >
            <v-icon
              color="info"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>

        <span>Refresh</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            v-bind="attrs"
            light
            icon
            v-on="on"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <span>Change Date</span>
      </v-tooltip>
    </template>

    <h3 class="my-card-title-style">
      {{ rightChartDescription.heading }}
    </h3>

    <p class="my-card-subtitle-style">
      {{ rightChartDescription.subHeading }}
    </p>
    <p
      v-if="noDataExist"
      class="alert-style"
    >
      No Data to Display.
    </p>

    <template v-slot:actions>
      <v-icon
        class="mr-1"
        small
        dense
      >
        mdi-clock-outline
      </v-icon>
      <span class="my-updation-text-style">Updated {{ rightChartDescription.updatedAt | diffHumans }}</span>
    </template>
  </base-chart-card>
</template>
<script>
  import moment from 'moment';
  import { isDataExist } from 'src/helpers/chart-data-helper';

  export default {
    name: 'DashBoardRightChart',
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
    },
    data: () => ({
      title: 'Board Health Checks',
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'left',
          maxHeight: '10px',
          align: 'left',
          display: true,
          textAlign: 'left',
          text: 'Board Health Checks',
          labels: {
            fontColor: '#263238',
          },
        },
      },
    }),
    computed: {
      chartData () {
        return this.$store.getters['dashboard/getRightChart'];
      },
      middleChartDescription () {
        return this.$store.getters['dashboard/getMiddleChartDescription'];
      },
      dataExist () {
        return this.chartData.length > 0;
      },
      showChart () {
        return Object.keys(this.dataCollection).length > 0;
      },
      dataCollection () {
        if (this.dataExist === false) {
          return {};
        }
        return this.generateDataCollection();
      },
      rightChartDescription () {
        return this.$store.getters['dashboard/getRightChartDescription'];
      },
      noDataExist () {
        const dataExist = isDataExist(this.chartData);
        if (dataExist === true) {
          return false;
        }
        return true;
      },
    },
    async mounted () {
      await this.$store.dispatch('digiboards/fetchDigiBoards');
      this.generateRightChartDescription();
      this.generateRightChart();
    },
    methods: {
      getDigiBoardIndex () {
        const digiBoards = this.$store.getters['digiboards/getDigiBoards'];
        return digiBoards[0].external_id;
      },
      generateRightChartDescription () {
        const todaysDate = moment().format('DD/MM/YYYY');
        this.$store.dispatch('dashboard/fetchRightChartDescription', {
          heading: 'Board Health Status',
          subHeading: `Board health status of ${todaysDate}`,
          updatedAt: moment(),
        });
      },
      generateRightChart () {
        this.$store.dispatch('dashboard/fetchRightChartTotalData', {
          params: {
            eventTriggeredAt: moment().startOf('day').toISOString(),
          },
          label: 'Total',
          color: '#FB8C00',
        });
        this.$store.dispatch('dashboard/fetchRightChartSuccessfulData', {
          params: {
            eventTriggeredAt: moment().startOf('day').toISOString(),
            status: 'completed',
          },
          label: 'Successful',
          color: '#4CAF50',
        });
        this.$store.dispatch('dashboard/fetchRightChartFailedData', {
          params: {
            eventTriggeredAt: moment().startOf('day').toISOString(),
            status: 'pending',
          },
          label: 'Failed',
          color: '#F44336',
        });
      },
      generateDataCollection () {
        const actionCount = [];
        const labels = [];
        const itemColor = [];
        for (const result of this.chartData) {
          actionCount.push(result.count);
          labels.push(result.label);
          itemColor.push(result.color);
        }
        return {
          labels: labels,
          datasets: [
            {
              data: actionCount,
              backgroundColor: itemColor,
              borderColor: '#fff',
              fill: false,
              hoverOffset: 4,
            },
          ],
        };
      },
    },
  };
</script>
<style scoped>
.alert-style {
  color: #C62828;
  text-align: center;
}
.my-card-title-style {
  color: #37474F;
  margin-left: 7px;
  margin-top: 10px;
  font-size: 18px;
}
.my-card-subtitle-style {
  color: #37474F;
  margin-left: 7px;
  margin-top: 7px;
  font-size: 14px;
}
.my-updation-text-style {
  color: #37474F;
  font-size: 12px;
}
</style>
